import styled, { css, createGlobalStyle } from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { color, contrastingFontColor } from 'ui/themes/utils'

export const HostStyles = createGlobalStyle`
  :root, :host {
    /* Colors */
    --date-picker-icon-color: var(--color-accent-foreground);
    --date-picker-background-color: var(--color-white, #ffffff);
    --date-picker-text-color: var(--color-typo, #0c2747);
    --date-picker-placeholder-color: var(--color-placeholder, #0c27471a);
    --date-picker-cleanstate-background-color: var(--color-accent-background);
    --date-picker-cleanstate-text-color: var(--color-accent-foreground);
    --date-picker-error-color: var(--color-red, #f85454);

    /* Sizes */
    --date-picker-wrapper-padding: 0.5rem;
    --date-picker-cleanstate-padding: 0.75rem 1.25rem;
    --date-picker-section-padding: 0.75rem;
    --date-picker-title-size: 1.125rem;
    --date-picker-title-line-height: 1.75rem;
    --date-picker-text-size: 1rem;
    --date-picker-label-size: 0.875rem;
    --date-picker-value-size: 0.75rem;
    --date-picker-text-line-height: 1.5rem;
    --date-picker-border-radius: 0.5rem;

    /* Other styles */
    --date-picker-box-shadow: 0 1px 2px rgba(33, 59, 71, 0.12), 0 4px 12px rgba(33, 59, 71, 0.12);
    --date-picker-section-border: 1px solid ${color('Misc/Divider')};

    --date-picker-cleanstate-alignment: left;
    --date-picker-alignment: left;

    @media (min-width: 820px) {
      --date-picker-wrapper-padding: 1rem;
    }
  }
`

export const DatePicker = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  font-size: 16px;
  font-family: var(--font-body);
`

export const Icon = styled(FontAwesomeIcon)`
  max-width: 24px;
  width: 100%;

  color: var(--date-picker-icon-color);
`

export const CalendarIcon = styled(Icon)`
  max-height: 24px;

  margin-right: 16px;
`

export const ChevronIcon = styled(Icon)`
  max-width: 12px;
`

export const CleanstateLabels = styled.div`
  width: 100%;
  margin-right: 16px;

  color: var(--date-picker-cleanstate-text-color);
`

export const CleanstateTitle = styled.div`
  font-size: var(--date-picker-title-size);
  line-height: var(--date-picker-title-line-height);
  font-weight: 600;
`

export const CleanstateLabel = styled.div`
  font-size: var(--date-picker-text-size);
  line-height: var(--date-picker-text-line-height);
`

export const Cleanstate = styled.div`
  display: flex;
  align-items: center;

  text-align: var(--date-picker-cleanstate-alignment);

  background-color: var(--date-picker-cleanstate-background-color);

  padding: var(--date-picker-cleanstate-padding);

  border-radius: var(--date-picker-border-radius);

  cursor: pointer;

  min-height: 56px;

  ${({ brandingColor }) => brandingColor && css`
    background-color: var(--date-picker-cleanstate-background-color, ${brandingColor});

    ${CleanstateLabels} {
      color: var(--date-picker-cleanstate-text-color, ${contrastingFontColor(brandingColor)});
    }

    ${Icon} {
      color: var(--date-picker-icon-color, ${contrastingFontColor(brandingColor)});
    }
  `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  background-color: var(--date-picker-background-color);

  padding: var(--date-picker-wrapper-padding) 0;

  box-shadow: var(--date-picker-box-shadow);
  border-radius: var(--date-picker-border-radius);

  text-align: var(--date-picker-alignment);
`

export const SectionGroup = styled.div`
  display: flex;
  flex-grow: 1;
  cursor: pointer;
`

export const Section = styled.div`
  flex: 1 1 0;
  padding: 0 var(--date-picker-section-padding);

  &:not(:last-child) {
    border-right: var(--date-picker-section-border);
  }
`

export const Label = styled.p`
  font-size: var(--date-picker-label-size);
  line-height: var(--date-picker-text-line-height);

  color: var(--date-picker-text-color);

  font-weight: 600;

  @media (min-width: 820px) {
    display: block;
  }
`

export const Value = styled.p`
  font-size: var(--date-picker-value-size);
  line-height: var(--date-picker-text-line-height);

  color: var(--date-picker-text-color);

  font-weight: 400;

  ${({ isPlaceholder }) => isPlaceholder && css`
    font-size: var(--date-picker-text-size);
    line-height: var(--date-picker-text-line-height);
    font-weight: 400;
    color: var(--date-picker-placeholder-color);
  `}

  ${({ isValid }) => !isValid && css`
    color: var(--date-picker-error-color);
  `}
`
